import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: '[app-menu-btn]',
  imports: [CommonModule, TranslateModule],
  templateUrl: './menu-btn.component.html',
})
export class MenuBtnComponent {
  isShowDotsMenu = input<boolean>();
  title = input<string>();
  icon = input<MenuBtnIcon>();
  color = input<MenuBtnColor>();
  //*btnTitle
  btnTitle = computed<string>(() => {
    let t: string = this.title() || '';
    switch (this.icon()) {
      case 'edit':
        t = 'common.edit';
        break;
      case 'delete':
        t = 'common.delete';
        break;
      case 'details':
        t = 'common.detail';
        break;
    }
    return t;
  });
  // *btnIcon
  btnIcon = computed<string>(() => {
    let icon: string = '';
    switch (this.icon()) {
      case 'edit':
        icon = 'mdi-20px mdi-pencil-outline';
        break;
      case 'delete':
        icon = ' mdi-20px mdi-trash-can-outline';
        break;
      case 'details':
        icon = ' mdi-20px mdi-text-box-search-outline';
        break;
      default:
        icon = this.icon();
        break;
    }
    return icon;
  });
  //* btnColor
  btnColor = computed<string>(() => {
    let c: string = 'mdi';
    if (this.color()) {
      switch (this.color()) {
        case 'navyBlue':
          c = 'text-navyBlue';
          break;
        case 'blue':
          c = 'text-blue';
          break;
        case 'red':
          c = 'text-danger';
          break;
        case 'indigo':
          c = 'text-purple';
          break;
        case 'green':
          c = 'text-success';
          break;
        case 'yellow':
          c = 'tw-text-amber-500';
          break;
        case 'gray':
          c = 'tw-text-gray-500 dark:tw-text-gray-300';
          break;
      }
    } else
      switch (this.icon()) {
        case 'edit':
          c = 'text-navyBlue';
          break;
        case 'delete':
          c = 'text-danger';
          break;
        case 'details':
          c = 'text-gray';
          break;
      }
    return c;
  });
}

export type MenuBtnIcon = 'delete' | 'edit' | 'details' | (string & {});
export type MenuBtnColor =
  | 'blue'
  | 'red'
  | 'indigo'
  | 'gray'
  | 'green'
  | 'yellow'
  | 'navyBlue'
  | (string & {});
